import { __awaiter, __generator } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import useDebounce from '../../../../_externals/.pnpm/react-use@17.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-use/esm/useDebounce.js';

var useAddressSearch = function (apiKey, location, searchText, setSearchText, onAddressSelect) {
    var _a = React.useState(true), shouldSearch = _a[0], setShouldSearch = _a[1];
    var _b = React.useState([]), results = _b[0], setResults = _b[1];
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(null), error = _d[0], setError = _d[1];
    var fetchAddresses = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var queryString, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    queryString = new URLSearchParams(params).toString();
                    return [4 /*yield*/, fetch("https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws?".concat(queryString), {
                            method: "GET",
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    setResults(data.Items || []);
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    setError(error_1.message);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var fetchAddressDetails = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var queryString, response, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    queryString = new URLSearchParams({
                        Key: apiKey,
                        Id: id,
                    }).toString();
                    return [4 /*yield*/, fetch("https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws?".concat(queryString), {
                            method: "GET",
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (onAddressSelect && data.Items && data.Items.length > 0) {
                        onAddressSelect(data.Items[0]);
                        setSearchText("");
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    setError(error_2.message);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useDebounce(function () {
        if (searchText && shouldSearch) {
            fetchAddresses({
                Key: apiKey,
                Text: searchText,
                Origin: location,
                Countries: location,
            });
        }
        else if (!shouldSearch) {
            setShouldSearch(true);
        }
        else {
            setResults([]);
            setLoading(false);
        }
    }, 300, [searchText]);
    var handleResultClick = function (result) {
        if (result.Type === "Address") {
            fetchAddressDetails(result.Id);
        }
        else {
            // We add an empty space to the search text on result click to
            // allow the user to use the backspace to get the previous results.
            setShouldSearch(false);
            setSearchText("".concat(searchText, " "));
            fetchAddresses({
                Key: apiKey,
                Container: result.Id,
            });
        }
    };
    return { results: results, loading: loading, error: error, handleResultClick: handleResultClick };
};

export { useAddressSearch };
//# sourceMappingURL=useAddressSearch.js.map
